import { render, staticRenderFns } from "./SiteArticleFeed.vue?vue&type=template&id=537f9798&"
import script from "./SiteArticleFeed.vue?vue&type=script&lang=js&"
export * from "./SiteArticleFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports